import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';

import { RootState } from 'app/app.config';

import * as fromReportDetails from './report-details.reducer';

export const reportDetailsFeatureKey = 'report-details';

export interface ReportDetailsState {
    [reportDetailsFeatureKey]: fromReportDetails.State;
}

export interface State extends RootState {
    [reportDetailsFeatureKey]: ReportDetailsState;
}

/** Provide reducer in AoT-compilation happy way */
export function reducers(state: ReportDetailsState | undefined, action: Action) {
    return combineReducers({
        [reportDetailsFeatureKey]: fromReportDetails.reportDetailsReducer,
    })(state, action);
}

export const selectReportDetailsState = createFeatureSelector<ReportDetailsState>(reportDetailsFeatureKey);

export const selectReportDetailsEntitiesState = createSelector(
    selectReportDetailsState,
    (state: ReportDetailsState) => state?.[reportDetailsFeatureKey],
);

export const selectReport = createSelector(
    selectReportDetailsEntitiesState,
    (state: fromReportDetails.State) => state?.report,
);

export const selectIsPrinting = createSelector(
    selectReportDetailsEntitiesState,
    (state: fromReportDetails.State) => state?.isPrinting,
);

export const selectKpiSetDetails = createSelector(
    selectReportDetailsEntitiesState,
    (state: fromReportDetails.State) => state?.kpiSetDetails,
);

export const selectShowReportLoader = createSelector(
    selectReportDetailsEntitiesState,
    (state: fromReportDetails.State) => state.showReportLoader,
);

export const selectShowReportContentLoader = createSelector(
    selectReportDetailsEntitiesState,
    (state: fromReportDetails.State) => state.showReportContentLoader,
);

export const selectReportError = createSelector(
    selectReportDetailsEntitiesState,
    (state) => state.reportError,
);

export const selectReportEdition = createSelector(
    selectReportDetailsEntitiesState,
    (state: fromReportDetails.State) => state.reportEdition,
);

export const selectFilterOperationTime = createSelector(
    selectReportDetailsEntitiesState,
    (state: fromReportDetails.State) => state.filterOperationTime,
);

export const selectReportEditionError = createSelector(
    selectReportDetailsEntitiesState,
    (state) => state.reportEditionError,
);

export const selectLatestReportTemplate = createSelector(
    selectReportDetailsEntitiesState,
    (state) => state.latestReportTemplate,
);

export const selectReportEditionsList = createSelector(
    selectReportDetailsEntitiesState,
    (state) => state.reportEditions,
);

export const selectDialogError = createSelector(
    selectReportDetailsEntitiesState,
    (state) => state?.dialogError,
);
